import jQuery from 'jquery';

;(function($){

/**
** [fixedHeader]
**/
const header = $('header'),
      headerTop = header.offset().top;
function headerFixed(){
  if($(window).scrollTop() >= headerTop){
    header.addClass('l-headerFixed');
  } else {
    header.removeClass();
  }
}
$(window).on('load scroll', headerFixed);
headerFixed();

/**
** [globalNavi+footerNavi]
**/
const mediaQuery = window.matchMedia('(max-width:813px)');
rwdSetting(mediaQuery);
mediaQuery.addEventListener('change', rwdSetting);

function rwdSetting(point){
  if (point.matches) {
//hamburger@smp
    $('header').append('<div class="hamburger"><span></span><span></span><span></span></div>');
    $('.hamburger').on('click', function(){
      $(this).toggleClass('open');
      $(this).prev().slideToggle('1000');
    });
//megaMenu@smp
    $('.l-navList-megaTrigger').append('<span class="megaMenu"/>');
    $('.megaMenu').on('click', function(){
      $(this).toggleClass('open').parent().next('.l-navList-megaContent').stop().slideToggle();
      $('.megaMenu').not($(this)).removeClass('open').parent().next('.l-navList-megaContent').slideUp();
    });
//footerMenu
    $('dt.l-footer-listCategory').append('<span class="footerMenu"/>');
    $('.footerMenu').on('click', function(){
      $(this).toggleClass('open').parent().next('dd').stop().slideToggle();
      $('.footerMenu').not($(this)).removeClass('open').parent().next('dd').slideUp();
    });
//reSet
    $('nav').removeAttr('style');
    $('.l-navList-megaTrigger').removeClass('open');
//  $('.l-navList-megaContent').removeAttr('style');
//  $('.l-navList-mega').off('mouseover');
  } else {
//megaMenu@pc
//  $('.l-navList-mega').on('mouseover', function(){
//    $(".l-navList-megaContent", this).stop().slideDown(250);
//  });
//  $('.l-navList-mega').on('mouseout', function(){
//    $('.l-navList-megaContent', this).stop().slideUp(250);
//  });
//reSet
    $('nav').removeAttr('style');
    $('.hamburger').remove();
    $('.megaMenu').remove();
    $('.l-navList-megaContent').removeAttr('style');
    $('.footerMenu').remove();
    $('.l-footer-listBlock dd').removeAttr('style');
  }
}

/**
** [smoothScroll]
**/
function smoothScroll(href){
  let headerHeight = $('header').eq(0).height();
  let localNavHeight = (!window.matchMedia('(max-width:813px)').matches && $('.c-localNav-container').length) ? $('.c-localNav-container').innerHeight() : 0;
  let target = $(href == '#' || href == '' ? 'html' : href);
  if(!target.length) return;
  let position = target.offset().top - headerHeight - localNavHeight;
  if(position > (headerHeight + localNavHeight)){
    $('html, body').animate({scrollTop:position}, 550, 'swing');
  }
}
let href= location.hash;
smoothScroll(href);
$('a[href^="#"]').on('click', function(){
  let href= $(this).attr('href');
  smoothScroll(href);
  return false;
});

/**
** [gotOtop]
**/
$(window).on('load scroll', function(){
  if($(window).scrollTop() > 200) {
    $('.l-gototop').addClass('is-gotoHeaven');
  } else {
    $('.l-gototop').removeClass('is-gotoHeaven');
  }
});
$('.l-gototop').on('click', function(){
  $('html,body').animate({scrollTop:0},'1000');
});

/**
** [visibleRange]
**/
function visibleRange() {
  $('.c-switch').each(function(){
    let pos = $(this).offset().top;
    let scroll = $(window).scrollTop();
    let windowHeight = $(window).height();
    if (scroll -10 > pos - windowHeight + windowHeight/50){
      $(this).addClass('is-switch_on');
    }
  });
}
$(function(){
  visibleRange();
});
$(window).on('load scroll', function(){
  visibleRange();
});

}(jQuery));